import { validateEvent } from "./protocol.js";
export function createEffectRouter(deps) {
    return {
        handle(parsed) {
            if (!deps.interactive)
                return false;
            const ev = validateEvent(parsed);
            if (!ev)
                return false;
            if (ev.type === "request_page_context") {
                deps.publishPageContext();
                return true;
            }
            if (ev.type === "navigate_to_page") {
                deps.navigate(ev.path);
                return true;
            }
            if (ev.type === "scroll_to_section") {
                deps.scrollToSection(ev.selector);
                return true;
            }
            return false; // booking + handoff events are state reductions, not effects
        },
    };
}
